<div class="flex flex-col">
  <div class="notification-message-container m-0 m-b-20 flex justify-between items-center">
    <div>
      <span>Note:</span> <span>Please select from the available Tags below which will allow the system to automatically suggest
      appropriate Hallmarks for this Case. You can customize this list of Tags on a per-Hallmark basis via the Library > Reporting Logic screen.</span>
    </div>
  </div>

  <div *ngFor="let selectorModel of selectorList" class="container flex flex-row full-grow-no-shrink-no-basis">
    <particle-tree-selector
      [isParentNodeCollapsible]="selectorModel.isParentNodeCollapsible$"
      [title]="selectorModel.selectorTitle"
      [treeData]="selectorModel.selectorData$"
      [quickSelections]="selectorModel.selectorQuickSelections$"
      [isRadioSelector]="selectorModel.isRadioSelector"
      (selectionChanged)="onSelectionChange($event, selectorModel)">
    </particle-tree-selector>
  </div>
</div>

